import { EditDatasetForm } from '@/components/EditDatasetForm';
import type { DatasetDetail } from '@/queries/datasets';
import Modal from 'antd/es/modal';
import theme from 'antd/es/theme';
import React from 'react';

export interface EditDatasetModalProps {
  open: boolean;
  dataset: DatasetDetail;
  teamId: string;
  onCancel: () => void;
  onSuccess?: (updatedDataset: DatasetDetail) => void;
  readOnlyFields?: ('name' | 'description')[];
}

export const EditDatasetModal: React.FC<EditDatasetModalProps> = ({
  open,
  dataset,
  teamId,
  onCancel,
  onSuccess,
  readOnlyFields,
}) => {
  const { token } = theme.useToken();

  const handleSuccess = (updatedDataset: DatasetDetail) => {
    onSuccess?.(updatedDataset);
    onCancel(); // Close modal after successful update
  };

  const handleError = () => {
    // Error is already shown by the form component
    // Modal stays open to allow user to retry
    // The error is logged by the form component
  };

  return (
    <Modal
      title="Edit Dataset"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={`${token.controlHeightLG * 15}px`}
      maskClosable={false} // Prevent accidental closure
    >
      <EditDatasetForm
        dataset={dataset}
        teamId={teamId}
        onSuccess={handleSuccess}
        onCancel={onCancel}
        onError={handleError}
        readOnlyFields={readOnlyFields}
        showActions={true}
      />
    </Modal>
  );
};

export default EditDatasetModal;